module.exports = __webpack_public_path__ + "824673981f1300ac51e90e7ce63a0889.svg";